import {
  NEW_MAIN_PAGE_BLOCK_TYPES,
  NewMainPageBlocksOrderConfig,
  NewMainPageBlockType,
  TRoundingRules,
} from '@web-catalog/types/omicron';

import {FieldValidator} from '@utils/omicron';

const isRoundingRule = (value: unknown): value is TRoundingRules[number] => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  return 'min' in value && 'text' in value;
};

export const RoundingRulesValidator: FieldValidator<TRoundingRules | boolean> =
  {
    is: (value): value is TRoundingRules | boolean => {
      if (typeof value === 'boolean') {
        return true;
      }
      if (Array.isArray(value)) {
        return value.every(isRoundingRule);
      }
      return false;
    },
    fallback: false,
  };

const isNewMainPageBlockType = (
  value: unknown,
): value is NewMainPageBlockType => {
  return (
    typeof value === 'string' &&
    (NEW_MAIN_PAGE_BLOCK_TYPES as ReadonlyArray<string>).includes(value)
  );
};

export const NewMainPageBlocksOrderConfigValidator: FieldValidator<NewMainPageBlocksOrderConfig> =
  {
    is: (value): value is NewMainPageBlocksOrderConfig => {
      if (typeof value !== 'object') {
        return false;
      }
      return (
        'MAIN' in value &&
        'GAMES' in value &&
        Array.isArray(value.MAIN) &&
        value.MAIN.every(isNewMainPageBlockType) &&
        Array.isArray(value.GAMES) &&
        value.GAMES.every(isNewMainPageBlockType)
      );
    },
    fallback: {
      MAIN: [
        'selection_with_app_cards',
        'top_apps',
        'selection_cards',
        'selection_with_app_list',
        'articles',
      ],
      GAMES: [
        'selection_with_app_cards',
        'top_apps',
        'selection_cards',
        'selection_with_app_list',
        'articles',
      ],
    },
  };
